import { render, staticRenderFns } from "./Radingcenter.vue?vue&type=template&id=419f1f26&scoped=true"
import script from "./Radingcenter.vue?vue&type=script&lang=js"
export * from "./Radingcenter.vue?vue&type=script&lang=js"
import style0 from "./Radingcenter.vue?vue&type=style&index=0&id=419f1f26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419f1f26",
  null
  
)

export default component.exports